import "./App.css";
import * as React from "react";

import PurpleHomeIcon from "./icons/Purple Home.png";
import WhiteHomeIcon from "./icons/White Home Icon.png";
import PurpleHangerIcon from "./icons/Purple Hanger.png";
import WhiteHangerIcon from "./icons/White Hanger Icon.png";
import PurpleFriendsIcon from "./icons/Friends Icon Purple.png";
import WhiteFriendsIcon from "./icons/Friends Icon White.png";
import PurpleProfileIcon from "./icons/Purple Profile.png";
import WhiteProfileIcon from "./icons/White Profile Icon.png";

import { IoIosArrowBack } from "react-icons/io";
import { iconColor, primaryColor } from "./colors";

import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import IconButton from "@mui/material/IconButton";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";

const NAV_INFO = [
  {
    label: "Home",
    logo: PurpleHomeIcon,
    activeLogo: WhiteHomeIcon,
    dest: "/home",
  },
  {
    label: "My Closet",
    logo: PurpleHangerIcon,
    activeLogo: WhiteHangerIcon,
    dest: "/mycloset",
  },
  {
    label: "Friends",
    logo: PurpleFriendsIcon,
    activeLogo: WhiteFriendsIcon,
    dest: "/friendsfeed",
  },
  {
    label: "Profile",
    logo: PurpleProfileIcon,
    activeLogo: WhiteProfileIcon,
    dest: `/friend?user=0&active=3`,
  },
];

function BottomNavigationButton(props) {
  const { label, logo, activeLogo, dest } = NAV_INFO[props.index];
  const navigate = useNavigate();
  const isActive = props.active === props.index;

  return (
    <BottomNavigationAction
      sx={isActive ? { color: "white" } : {}}
      onClick={() => navigate(dest)}
      showLabel
      label={label}
      icon={
        <img
          style={{ height: "2.5rem", marginBottom: "4px" }}
          src={isActive ? activeLogo : logo}
        />
      }
    />
  );
}

function NavBar(props) {
  const [value, setValue] = React.useState(0);

  return (
    <BottomNavigation
      value={value}
      onChange={(event, newValue) => {
        setValue(newValue);
      }}
      showLabels
      sx={{ backgroundColor: primaryColor, paddingBottom: 2, height: 100 }}
    >
      <BottomNavigationButton active={props.active} index={0} />
      <BottomNavigationButton active={props.active} index={1} />
      <BottomNavigationButton active={props.active} index={2} />
      <BottomNavigationButton active={props.active} index={3} />
    </BottomNavigation>
  );
}

function Titlebar(props) {
  return (
    <div className="Titlebar-container">
      <div>
        <IconButton onClick={props.onBackButtonClicked}>
          <IoIosArrowBack color={iconColor} size="3rem" />
        </IconButton>
      </div>
      <div className="Titlebar-text">{props.title}</div>
      <div style={{ width: 64 }}>{props.rightIcon}</div>
    </div>
  );
}

const theme = createTheme({
  palette: {
    primary: {
      main: "#e17667",
    },
    secondary: {
      main: "#A9A9A9",
    },
  },
  typography: {
    button: {
      textTransform: "none",
    },
  },
});

function NavBarLayout(props) {
  return (
    <ThemeProvider theme={theme}>
      <div className="Navbar-outer-container">
        {!props.hideTitlebar && (
          <Titlebar
            rightIcon={props.rightIcon}
            onBackButtonClicked={props.onBackButtonClicked}
            title={props.title}
          />
        )}
        <div className="Navbar-inner-container">{props.children}</div>
        <NavBar active={props.active} />
      </div>
    </ThemeProvider>
  );
}

export default NavBarLayout;
